import React, { useState } from 'react';
import { List } from 'antd';
import ReportDoc from '../../../components/ReportDoc/ReportDoc';
import { useNavigate } from 'react-router-dom';

const Education = (props) => {

    const navigate = useNavigate();
    const [data] = useState([
        {
            id: 1,
            name: 'Сургууль',
            path: 'school'
        },
        {
            id: 2,
            name: 'Гэрчилгээ',
            path: 'certificate'
        },
        {
            id: 4,
            name: 'Хэлний мэдлэг',
            path: 'language'
        }
    ]);

    const onPressNode = (p_item) => {
        navigate('/hrsuite/report/empbasic/education/' + p_item.path);
    }

    const renderItem = (item) => {
        return (
            <ReportDoc data={item} onClick={onPressNode} />
        );
    }

    return (
        <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
            <List
                grid={{
                    gutter: [0, 16]
                }}
                dataSource={data}
                renderItem={renderItem}
            />
        </div>
    );
}

export default Education;